angular.module('autoremind.communications')
    .directive('genderFilter', ['jobService',
    function (jobService) {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: 'app/communication/forms/communications-filter-gender.html',
            link: function (scope) {
                scope.searchByPet = scope.isVets;
                jobService.job.data.jobContent.targets[0].isPetBirthday = scope.isVets ? true : undefined;
                jobService.job.filterChanged();
                scope.searchBy = function () {
                    scope.searchByPet = !scope.searchByPet;
                    // on switch clear all flags and get target as if no filters are there
                    jobService.job.jobTargetMale = false;
                    jobService.job.jobTargetFemale = false;
                    jobService.job.jobTargetPetMale = false;
                    jobService.job.jobTargetPetFemale = false;
                    jobService.job.jobTargetPetAge = undefined;
                    jobService.job.jobTargetAge = undefined;
                    var target = jobService.job.data.jobContent.targets[0];
                    target.gender = undefined;
                    target.petGender = undefined;
                    target.age = undefined;
                    target.petAge = undefined;
                    target.isPetBirthday = undefined;
                    if (scope.searchByPet) {
                        target.isPetBirthday = true;
                    }
                    jobService.job.filterChanged();
                };
            }
        };
    }]);
//# sourceMappingURL=communications-filter-gender.js.map